export var EAuthMode = /*#__PURE__*/function (EAuthMode) {
  /**
   * Стандартный режим с запросом прав на доступ
   */
  EAuthMode["Default"] = "default";
  /**
   * Автоматическое поднятие окна авторизации без запроса прав на доступ
   */
  EAuthMode["OneTap"] = "onetap";
  return EAuthMode;
}({});
export var EAuthStatus = /*#__PURE__*/function (EAuthStatus) {
  /**
   * Пользователь авторизован и разрешил доступ приложению
   */
  EAuthStatus["Connected"] = "connected";
  /**
   * Пользователь авторизован, но не разрешил доступ приложению
   */
  EAuthStatus["NotAuthorized"] = "not_authorized";
  /**
   * Пользователь не авторизован
   */
  EAuthStatus["Unknown"] = "unknown";
  return EAuthStatus;
}({});

/**
 * Mail.Ru OAuth API
 */